import React, { useEffect, useState } from "react";
import {
  CircularGaugeComponent,
  AxesDirective,
  AxisDirective,
  PointersDirective,
  PointerDirective,
  RangesDirective,
  RangeDirective,
} from "@syncfusion/ej2-react-circulargauge";
import axiosClient from "../Utils/axiosClient";

const GaugeChart = () => {
  const [data, setData] = useState(0);

  useEffect(() => {
    const fetchWhatsappQuality = async () => {
      try {
        const response = await axiosClient.get("/users/GetWhatsappQuality");

        if (response.status === 200) {
          const formattedData = response.data;

          let randomValue;

          if (formattedData === "GREEN")
            // randomValue = Math.floor(Math.random() * (100 - 90 + 1)) + 90;
            randomValue = 100;
          else if (formattedData === "ORANGE")
            randomValue = Math.floor(Math.random() * (89 - 70 + 1)) + 70;
          else if (formattedData === "RED")
            randomValue = Math.floor(Math.random() * (69 - 30 + 1)) + 30;
          // else randomValue = Math.floor(Math.random() * (30 - 0 + 1));
          else randomValue = 0;

          setData(randomValue);
        }
      } catch (error) {}
    };
    fetchWhatsappQuality();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CircularGaugeComponent id="gauge-chart" width="100%">
      <AxesDirective>
        <AxisDirective
          startAngle={270}
          endAngle={90}
          majorTicks={{ position: "Outside" }}
          minorTicks={{ position: "Outside" }}
        >
          <PointersDirective>
            <PointerDirective
              value={data}
              animation={{
                enable: true,
                duration: 1500,
              }}
            ></PointerDirective>
          </PointersDirective>
          <RangesDirective>
            <RangeDirective
              start={0}
              end={50}
              radius="110%"
              color="red"
            ></RangeDirective>
            <RangeDirective
              start={50}
              end={80}
              radius="110%"
              color="orange"
            ></RangeDirective>
            <RangeDirective
              start={80}
              end={100}
              radius="110%"
              color="green"
            ></RangeDirective>
          </RangesDirective>
        </AxisDirective>
      </AxesDirective>
    </CircularGaugeComponent>
  );
};

export default GaugeChart;
